import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { ReduxOrganization, ReduxState } from 'app/redux/ReduxInterfaces'
import { getPrequalifications } from 'app/services/sfAuth/sfData/sfPrequalification'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

export interface ActivePrequalification {
  id: string
  stage: string
  fundingStream: string
}

interface Prequalifications {
  query: UseQueryResult<ActivePrequalification[]>
  prequalificationsByStream: Record<string, ActivePrequalification[]>
}

/**
 * Prequalifications of the current organization, grouped by funding stream id.
 */
export const usePrequalifications = (): Prequalifications => {
  const organization = useSelector<ReduxState, ReduxOrganization>((state) => state.organization)

  const query = useQuery<ActivePrequalification[]>(['prequalifications', organization.id], {
    refetchOnWindowFocus: false,
    enabled: Boolean(organization.id),
    queryFn: async () =>
      (await getPrequalifications({
        searchParams: {
          Organization_Legal_Name__c: organization.id
        }
      })) as ActivePrequalification[]
  })

  const prequalificationsByStream = useMemo(() => {
    const byStream: Record<string, ActivePrequalification[]> = {}
    query.data?.forEach((obj) => {
      if (!(obj.fundingStream in byStream)) {
        byStream[obj.fundingStream] = []
      }
      byStream[obj.fundingStream].push(obj)
    })
    return byStream
  }, [query.data])

  return { query, prequalificationsByStream }
}
